export const PLACEHOLDER_CELL = 'N/A';
export const HEADER_TITLE = 'Monthly Revenue';
export const FOOTNOTE =
  // eslint-disable-next-line max-len
  'Optional perks for provider to choose at their own discretion! Comes with a standard Joint Investment Agreement (JIA). If interested to move forward, please submit a ticket.';
export const DISCLAIMER =
  // eslint-disable-next-line max-len
  'Last updated 1/26/24. We’ll make changes in the future as we add and edit the benefits, but will always apply changes fairly.';
